/**
 * @generated SignedSource<<0b23a25d796331821e408a5f5734c21f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveCustomerPixCreditCard_charge$data = {
  readonly customer: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly type: string | null | undefined;
  readonly value: number | null | undefined;
  readonly valueWithDiscount: number | null | undefined;
  readonly " $fragmentType": "PaymentActiveCustomerPixCreditCard_charge";
};
export type PaymentActiveCustomerPixCreditCard_charge$key = {
  readonly " $data"?: PaymentActiveCustomerPixCreditCard_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveCustomerPixCreditCard_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveCustomerPixCreditCard_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueWithDiscount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "c30a6251353e3fcf2c7982a90e2412cb";

export default node;
